import { useState } from "react";
import {agencyCertificateSelector} from "./util";

export const DefaultEACard = ({ data }) => {

  const [ selectedAgency, setSelectedAgency ] = useState( data.agencies[-1] !== undefined ? -1 : Object.keys( data.agencies ).sort()[0] )

  const earnDate = new Date( parseInt(data.earn_date) * 1000 )
  const year = earnDate.getFullYear();
  const month = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ][ earnDate.getMonth() ]
  const day = earnDate.getDate()

  return (
    <div className="tgbl-user-earned-accreditations__list__item tgbl-ea-card-layout-default tgbl-card tgbl-card--flow-column tgbl-card--is-elevated">
      <div className="tgbl-card__header tgbl-user-earned-accreditations__list__item__header">
        <div className="tgbl-user-earned-accreditations__list__item__header__details">
          { !data.content_id &&
            <h3 className="tgbl-user-earned-accreditations__list__item__header__details__title">
              <a href={data.content_link} target="_blank">{data.content_name}</a>
            </h3>
          }
          <div className="tgbl-user-earned-accreditations__list__item__header__details__stats tgbl-flex tgbl-flex--wrap tgbl-flex--density-20">
            { data.agencies[selectedAgency].earned_points.map((point, index) => <span
              key={`${selectedAgency}-${index}`} className="tgbl-chip tgbl-chip--style-icon"
            >
              <svg className="tgbl-icon tgbl-icon--clock" width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path fill="currentcolor" fillRule="evenodd" d="M10.0007 16.6663c3.6818 0 6.6666-2.9847 6.6666-6.66663 0-3.68189-2.9848-6.66666-6.6666-6.66666-3.68195 0-6.66672 2.98477-6.66672 6.66666 0 3.68193 2.98477 6.66663 6.66672 6.66663Zm0-11.45829c.3452 0 .625.27982.625.625v3.83217l2.2217 1.48112c.2872.1915.3648.5795.1733.8667-.1914.2872-.5795.3648-.8667.1734l-2.4919-1.6613c-.01573-.0102-.03097-.021-.04568-.0325-.13513-.1055-.22576-.2654-.23902-.4467-.00139-.0186-.00195-.0372-.00168-.05592V5.83301c0-.34518.27982-.625.62498-.625Z" clipRule="evenodd"/>
              </svg>
              <span className="tgbl-chip__content">{`${point.count} ${point.name}${point.count !== 1 ? 's' : ''}`}</span>
            </span> )}
            <span className="tgbl-chip tgbl-chip--style-icon">
              <svg className="tgbl-icon tgbl-icon--calendar-day" width="1em" height="1em" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <g clipPath="url(#a)" fill="currentcolor">
                  <path d="M19 7.8a1.4 1.4 0 0 0-1.4-1.4h-1.4v-.7a.7.7 0 1 0-1.4 0v.7h-2.1v-.7a.7.7 0 0 0-1.4 0v.7H9.2v-.7a.7.7 0 1 0-1.4 0v.7H6.4A1.4 1.4 0 0 0 5 7.8v1.4h14V7.8ZM5 17.6A1.4 1.4 0 0 0 6.4 19h11.2a1.4 1.4 0 0 0 1.4-1.4v-7H5v7ZM8.5 12h7a.7.7 0 1 1 0 1.4h-7a.7.7 0 1 1 0-1.4Z"/>
                </g>
                <defs>
                  <clipPath id="a">
                    <path fill="#fff" transform="translate(5 5)" d="M0 0h14v14H0z"/>
                  </clipPath>
                </defs>
              </svg>
              <span className="tgbl-chip__content">{`${month} ${day}, ${year}`}</span>
            </span>
          </div>
        </div>
      </div>

      <form className="tgbl-card__content tgbl-user-earned-accreditations__list__item__print-form" action={`${window.location.origin}/tgbl-cred-certificates`} target="_blank">
        { Object.keys(data.agencies).length > 1 &&
          <div className="tgbl-user-earned-accreditations__list__item__print-form__heading">Get your certificate</div>
        }
        { agencyCertificateSelector(data.agencies, selectedAgency, setSelectedAgency, 'Select a board to customize your certificate') }
      </form>
    </div>
  )
}
